import React, { FC, useMemo } from 'react'
import { sanityImageUrlBuilder } from '../../contexts/SanityClient'

export interface SanityImageProps {
  alt?: string
  caption?: string
  image?: string
  width?: number
}

const SanityImage: FC<SanityImageProps> = ({
  alt = '',
  caption = '',
  image = '',
}) => {
  const src = useMemo(
    () => sanityImageUrlBuilder.image(image).auto('format').toString(),
    [image]
  )

  return <img alt={alt || caption} src={src} />
}

export default SanityImage
